import { Loading as LoadingIcon } from '../Icon/icon'
import style from './Loading.module.scss'

interface LoadingProps {
  className?: string
}

const Loading = ({ className = '' }: LoadingProps) => {
  return (
    <div className={style.wrapper + ` ${className}`}>
      <LoadingIcon />
    </div>
  )
}

export default Loading
